import { useEffect, useRef, useState } from 'react';
import { Camera, ImagePlus, RotateCcw, X } from 'lucide-react';
import { toast } from 'sonner';
import Brand from './Brand';

export default function CameraCapture({ onCapture, onClose, onUpload }) {
  const videoRef = useRef(null);
  const streamRef = useRef(null);
  const [facingMode, setFacingMode] = useState('environment');
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let active = true;
    async function start() {
      try {
        streamRef.current?.getTracks().forEach((track) => track.stop());
        const stream = await navigator.mediaDevices.getUserMedia({
          video: { facingMode: { ideal: facingMode }, width: { ideal: 1920 }, height: { ideal: 1080 } },
          audio: false,
        });
        if (!active) return stream.getTracks().forEach((track) => track.stop());
        streamRef.current = stream;
        videoRef.current.srcObject = stream;
        await videoRef.current.play();
        setReady(true);
      } catch (error) {
        console.error(error);
        toast.error('Camera access was blocked. You can upload a photo instead.');
      }
    }
    start();
    return () => {
      active = false;
      streamRef.current?.getTracks().forEach((track) => track.stop());
    };
  }, [facingMode]);

  function capture() {
    const video = videoRef.current;
    if (!ready || !video?.videoWidth) return;
    const canvas = document.createElement('canvas');
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    canvas.getContext('2d').drawImage(video, 0, 0);
    onCapture(canvas.toDataURL('image/jpeg', 0.9));
  }

  return (
    <div className="camera-page">
      <video ref={videoRef} className="camera-video" playsInline muted />
      <div className="camera-shade" />
      <header className="camera-header">
        <Brand compact />
        <button className="icon-button glass-button" onClick={onClose} aria-label="Close camera"><X /></button>
      </header>
      <div className="camera-guide">
        <div className="camera-frame" aria-hidden="true">
          <span className="guide-corner guide-a" /><span className="guide-corner guide-b" />
          <span className="guide-corner guide-c" /><span className="guide-corner guide-d" />
          <div className="scan-beam" />
        </div>
        <div className="guide-copy"><strong>Frame the restaurant sign</strong><span>Keep the name clear and centered</span></div>
      </div>
      <div className="camera-controls">
        <label className="camera-side-button"><ImagePlus /><input hidden type="file" accept="image/*" onChange={onUpload} /></label>
        <button className="shutter" onClick={capture} disabled={!ready} aria-label="Take photo"><Camera /></button>
        <button className="camera-side-button" onClick={() => setFacingMode((mode) => mode === 'environment' ? 'user' : 'environment')} aria-label="Switch camera"><RotateCcw /></button>
      </div>
    </div>
  );
}
